// src/components/LogoutDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import LogoutHelper from "../Helper/LogoutHelper";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";


const LogoutDialog = ({ open, onClose }) => {
  const handleConfirm = () => {
    onClose();
    LogoutHelper.logout();
  };

  return (
    // <Dialog
    //   open={open}
    //   onClose={onClose}
    //   aria-labelledby="logout-dialog-title"
    // >
    //   <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
    //   <DialogContent>
    //     <DialogContentText>
    //       Are you sure you want to log out?
    //     </DialogContentText>
    //   </DialogContent>
    //   <DialogActions>
    //     <Button onClick={onClose} color="inherit">
    //       Cancel
    //     </Button>
    //     <Button onClick={handleConfirm} style={{backgroundColor:'black'}} variant="contained">
    //       Logout
    //     </Button>
    //   </DialogActions>
    // </Dialog>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <LogoutRoundedIcon color="error" />
          <Typography variant="h6" fontWeight={600}>
            Logout
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          sx={{
            color: "text.secondary",
            fontSize: "15px",
            lineHeight: 1.7,
          }}
        >
          Are you sure you want to log out? You will need to sign in again to
          access your account.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{
            borderRadius: 2,
            textTransform: "none",
            px: 3,
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          startIcon={<LogoutRoundedIcon />}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            px: 3,
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
